// extracted by mini-css-extract-plugin
export var container = "_mb-0";